/* eslint-disable react/prop-types */
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import StatisticsCard from './StatisticsCard';

const StatisticsCards = ({ statsData, lg }) => {
  const data = [];
  const signs = [
    'positive',
    'neutral',
    'negative',
    'Excellent',
    'Good',
    'Average',
    'Below Average',
    'Poor',
    'Very Poor'
  ];

  let signIndex = 0; // To keep track of the current sign index

  for (const key in statsData) {
    if (Object.prototype.hasOwnProperty.call(statsData, key)) {
      const item = statsData[key];
      data.push({
        value: item?.count,
        title: item?.label,
        sign: signs[signIndex] // Assign the sign based on the current index
      });

      signIndex = (signIndex + 1) % signs.length; // Move to the next sign, wrap around if needed
    }
  }

  return (
    <Row className="g-3 mb-0">
      {data.map((item, index) =>
        item.title ? (
          <Col key={item.title} sm={6} md={6} lg={lg}>
            <StatisticsCard
              stat={item}
              style={{ minWidth: '10rem', height: '100%' }}
              index={index}
            />
          </Col>
        ) : null
      )}
    </Row>
  );
};

export default StatisticsCards;
